module.exports = ":host {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n\n.charts-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  height: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/charts/charts.component.scss
// module id = ./src/app/components/charts/charts.component.scss
// module chunks = main